import { CheckCircle, CircleNotch, type Icon } from "@phosphor-icons/react";
import clsx from "clsx";

import type { ReactNode } from "react";

interface OnboardingItemProps {
  icon: Icon;
  label: string;
  description: string;
  isCompleted: boolean;
  actionComponent: ReactNode;
  isLoading?: boolean;
}

export default function OnboardingItem({
  icon: Icon,
  label,
  description,
  isCompleted,
  actionComponent,
  isLoading = false,
}: OnboardingItemProps) {
  return (
    <div className="py-3 px-4 flex items-center gap-x-3.5">
      <span className="size-8 rounded-xl bg-black-700 inline-flex items-center justify-center shadow-[0_3.429px_6.857px_2.286px_rgba(17,24,39,0.20),_0_0_2.286px_2.286px_rgba(255,255,255,0.16)_inset,_0_-3.184px_2.122px_0_rgba(0,0,0,0.40)_inset,_0_3.184px_2.122px_0_rgba(255,255,255,0.20)_inset,_0_4.245px_4.245px_0_rgba(0,0,0,0.25)]">
        <Icon weight="fill" className="text-white" size={16} />
      </span>

      <div className="flex-1">
        <h4
          className={clsx(
            "text-sm-bold",
            isCompleted && "text-black-500 line-through",
          )}
        >
          {label}
        </h4>
        <p className="max-lg:hidden text-xs-medium text-black-500">
          {description}
        </p>
      </div>

      {isLoading ? (
        <CircleNotch size={20} className="animate-spin text-black-500" />
      ) : isCompleted ? (
        <CheckCircle size={20} weight="fill" className="fill-green-500" />
      ) : (
        actionComponent
      )}
    </div>
  );
}
